module.exports = __webpack_public_path__ + "img/img_company_tec.5b1f1708.svg";